import baseAction from './_base';
import {HAS_PRODUCT_ACCESS} from './actionTypes';

export function hasProductAccess() {
  return baseAction(HAS_PRODUCT_ACCESS, '/v1/admin/hasProductAccess');
}



/** WEBPACK FOOTER **
 ** ./src/_shared/actions/hasProductAccess.js
 **/